import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBSElEXpkx0nEf5HGxyRxrB4ZTS_TSZbHE',
  authDomain: 'blog-app-ai-7227c.firebaseapp.com',
  projectId: 'blog-app-ai-7227c',
  storageBucket: 'blog-app-ai-7227c.firebasestorage.app',
  messagingSenderId: '215252691142',
  appId: '1:215252691142:web:1bc2c09834c96cd8c48fc7',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
